<div class="assignment-container">

  <!-- Header -->
  <div class="page-header d-flex justify-content-between align-items-center mb-3">
    <h4 class="mb-0">
      
      CUSTOMER SURVEY ASSIGNMENT
    </h4>

    <button class="btn btn-success" (click)="onSubmit()" [disabled]="loading">
      <i class="fas fa-save"></i> SUBMIT
    </button>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="text-center py-5">
    <div class="spinner-border text-primary"></div>
    <p class="mt-2">Submitting assignment...</p>
  </div>

  <div *ngIf="!loading">

    <!-- Survey Dropdown -->
    <div class="card mb-4">
      <div class="card-header">
        <h5><i class="fas fa-clipboard-list"></i> Select Survey</h5>
      </div>
      <div class="card-body">
        <select class="form-control" [(ngModel)]="selectedSurvey">
          <option value="">Select Survey</option>
          <option *ngFor="let survey of surveyDropdown" [value]="survey.survey_id">
            {{ survey.survey_number }} - {{ survey.survey_title }} ({{ survey.status }})
          </option>
        </select>
      </div>
    </div>

    <!-- Assignment Details -->
    <div class="card">
      <div class="card-header">
        <h5><i class="fas fa-users"></i> Assignment Details</h5>
      </div>

      <div class="card-body">

        <!-- EMPLOYEE DROPDOWN -->
        <div class="mb-4">
          <h6>EMPLOYEE</h6>
          <ng-select
            [items]="employeeDropdown"
            bindLabel="employee_name"
            [multiple]="false"
            [searchable]="true"
            [clearable]="true"
            placeholder="Search Employee Here"
            [(ngModel)]="selectedEmployee">
          </ng-select>
        </div>

        <!-- CUSTOMER DROPDOWN -->
        <div class="mb-4">
          <h6>CUSTOMERS</h6>
          <ng-select
            [items]="customerDropdown"
            bindLabel="customer_name"
            [multiple]="true"
            [closeOnSelect]="false"
            [searchable]="true"
            [clearable]="false"
            placeholder="Search Customer Here"
            [(ngModel)]="selectedCustomers">
          </ng-select>
        </div>

        <hr class="my-4">

        <!-- SELECTED CUSTOMERS ONLY -->
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between align-items-center">
              <h6>SELECTED CUSTOMERS ({{ selectedCustomers.length }})</h6>

              <button class="btn btn-sm btn-danger"
                      (click)="selectedCustomers = []"
                      [disabled]="selectedCustomers.length === 0">
                <i class="fas fa-trash"></i> DISCARD
              </button>
            </div>

            <div class="selected-list mt-3">
              <div *ngIf="selectedCustomers.length === 0"
                   class="text-center text-muted py-4">
                No customers selected
              </div>

              <div *ngFor="let cust of selectedCustomers"
                   class="selected-item d-flex justify-content-between">
                <span>{{ cust.customer_name }}</span>
                <button class="btn btn-sm btn-link text-danger"
                        (click)="removeCustomer(cust.customer_id)">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>

</div>